<template>
  <div class="space-y-6">
    <div class="flex items-start gap-4">
      <div class="flex-1 space-y-4">
        <div class="grid gap-5 md:grid-cols-[2fr_1fr] xl:items-start">
          <div class="min-w-0 space-y-4">
            <div class="bg-white/30 dark:bg-white/5! app-border-card-calss shadow-sm !w-full !rounded-lg">
              <div class="space-y-4 p-3 sm:p-4">
                <div class="flex items-start gap-3">
                  <AppAvatar
                    :image="primaryContactAvatar"
                    :label="primaryContactInitials"
                    class="!w-9 !h-9 !text-xs !font-bold !text-white !bg-[var(--p-primary-color)]"
                  />
                  <div class="flex-1 min-w-0">
                    <div class="text-xs mb-1 dark:text-[var(--p-text-color)]">
                      {{ $t('whatsapp.initiate_conversation') }}
                    </div>
                    <div
                      class="text-sm text-[var(--p-surface-600)] dark:text-[var(--p-surface-200)]"
                    >
                      <strong>{{ contacts.length }}</strong>
                      {{ contacts.length === 1 ? 'contacto' : 'contactos' }}
                    </div>
                  </div>
                </div>

                <div
                  v-if="contacts.length > 0 && contacts.length <= 5"
                  class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1"
                >
                  <div
                    v-for="contact in contacts"
                    :key="contactKey(contact)"
                    class="min-w-0 text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)] flex items-center gap-2"
                  >
                    <Phone v-if="contact.is_manual" :size="12" class="shrink-0" />
                    <User v-else :size="12" class="shrink-0" />

                    <span
                      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)] truncate"
                    >
                      {{ contact.name || contact.phone }}
                    </span>

                    <span
                      v-if="contact.name && contact.phone"
                      class="shrink-0 text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)]"
                    >
                      ({{ contact.phone }})
                    </span>
                  </div>
                </div>

                <div v-else-if="contacts.length > 5">
                  <Button
                    :label="`Ver ${contacts.length} contactos`"
                    text
                    size="small"
                    @click="showContactsList = !showContactsList"
                  >
                    <template #icon>
                      <ChevronUp v-if="showContactsList" :size="16" />
                      <ChevronDown v-else :size="16" />
                    </template>
                  </Button>

                  <div
                    v-if="showContactsList"
                    class="mt-2 grid max-h-40 grid-cols-1 gap-x-4 gap-y-1 overflow-y-auto rounded border border-[var(--p-surface-200)] bg-[var(--p-surface-50)] p-2 dark:border-[var(--p-surface-700)] dark:bg-[var(--p-surface-900)] sm:grid-cols-2"
                  >
                    <div
                      v-for="contact in contacts"
                      :key="contactKey(contact)"
                      class="min-w-0 text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)] flex items-center gap-2"
                    >
                      <Phone v-if="contact.is_manual" :size="12" class="shrink-0" />
                      <User v-else :size="12" class="shrink-0" />

                      <span
                        class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)] truncate"
                      >
                        {{ contact.name || contact.phone }}
                      </span>

                      <span
                        v-if="contact.name && contact.phone"
                        class="shrink-0 text-[var(--p-surface-400)] dark:text-[var(--p-surface-200)]"
                      >
                        ({{ contact.phone }})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="bg-white/30 dark:bg-white/5! app-border-card-calss shadow-sm !w-full !rounded-lg">
              <div class="flex flex-col gap-3 p-3 sm:flex-row sm:items-start sm:justify-between sm:px-2 sm:pr-2">
                <div class="flex min-w-0 items-start gap-3">
                  <IconMessage
                    width="20"
                    height="20"
                    class="text-[var(--p-primary-color)] mt-0.5"
                  />
                  <div class="flex-1 min-w-0">
                    <div
                      class="text-sm font-medium !text-[var(--p-primary-color)] dark:!text-[var(--p-text-color)]"
                    >
                      {{ $t('whatsapp.template_selected') }}
                    </div>
                  </div>
                </div>

                <div v-if="template" class="w-full rounded-2xl p-3 text-left sm:w-3/5 sm:p-4">
                  <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
                    <div class="min-w-0">
                      <p
                        class="truncate text-xs font-medium text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]"
                      >
                        {{ getTemplateDisplayName(template.content.name) }}
                      </p>
                      <p
                        class="mt-1 text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)]"
                      >
                        {{ template.content.language }}
                      </p>
                    </div>

                    <span
                      class="w-fit rounded-full px-2.5 py-1 text-[11px] font-semibold"
                      :class="getCategoryBadgeClass(template)"
                    >
                      {{ getTemplateCategoryLabel(template) }}
                    </span>
                  </div>

                  <p
                    class="mt-3 line-clamp-3 text-[12px] leading-5 text-[var(--p-surface-700)] dark:text-[var(--p-surface-300)]"
                  >
                    {{ getTemplatePreview(template) }}
                  </p>

                  <!-- <div
                      v-if="previewComponents.length > 0"
                      class="mt-4 space-y-2 border-t border-[var(--p-surface-200)] pt-4 dark:border-[var(--p-surface-700)]"
                    >
                      <div
                        v-for="(component, index) in previewComponents"
                        :key="index"
                        :class="{
                          'text-sm font-semibold dark:text-[var(--p-text-color)]':
                            component.type === 'HEADER',
                          'text-sm whitespace-pre-wrap dark:text-[var(--p-text-color)]':
                            component.type === 'BODY',
                          'text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]':
                            component.type === 'FOOTER',
                        }"
                      >
                        {{ component.text }}
                      </div>
                    </div> -->
                </div>
              </div>
            </div>

            <div class="bg-white/30 dark:bg-white/5! app-border-card-calss shadow-sm !w-full !rounded-lg">
              <div class="my-6 flex flex-col gap-3 p-3 sm:my-10 sm:flex-row sm:items-center sm:justify-between sm:px-2 sm:pr-6">
                <div class="flex min-w-0 items-start gap-3">
                  <IconPlane width="18" class="text-[var(--p-primary-color)] mt-0.5" />
                  <div class="flex-1 min-w-0">
                    <div
                      class="text-sm font-medium !text-[var(--p-primary-color)] dark:!text-[var(--p-text-color)]"
                    >
                      {{ $t('whatsapp.destination_conversation') }}
                    </div>
                  </div>
                </div>

                <div
                  v-if="destination"
                  class="bg-white/30 dark:bg-white/5! app-border-card-calss shadow-sm flex w-full min-w-0 items-center gap-2 rounded-md p-2 text-sm text-[var(--p-surface-600)] dark:text-[var(--p-surface-400)] sm:w-3/5 sm:gap-6"
                >
                  <IconCampaign
                    v-if="destination.type === 'campaign'"
                    width="14"
                    class="text-[var(--p-primary-color)]"
                  />
                  <IconAgent
                    v-if="destination.type === 'user'"
                    width="14"
                    class="text-[var(--p-primary-color)]"
                  />
                  <BotMessageSquare
                    v-if="destination.type === 'bot'"
                    width="14"
                    class="text-[var(--p-primary-color)]"
                  />
                  <span
                    class="min-w-0 truncate text-xs font-medium text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]"
                  >
                    {{ destination.campaign_name || destination.user_name || destination.bot_name }}
                  </span>
                  <span
                    class="text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-200)]"
                  >
                    ({{
                      destination.type === 'campaign'
                        ? 'Campaña'
                        : destination.type === 'user'
                          ? 'Agente'
                          : 'Bot'
                    }})
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center md:justify-start">
            <PreviewPhoneTemplate
              :body="props.template?.content.body || ''"
              :body-examples="previewBodyExamples"
              :header="previewHeader"
              :example-header="previewExampleHeader"
              :footer="props.template?.content.footer || ''"
              :buttons="previewButtons"
              :carousel="previewCarousel"
              :limited-time-offer="previewLimitedTimeOffer"
              :is-carousel="isCarouselTemplate"
              :combination="props.template?.combination || ''"
              :category="props.template?.content.category || ''"
              :profile-image-component="IconNebula"
              :scale="1.2"
            />

            <p
              v-if="!props.template"
              class="mt-3 text-center text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
            >
              {{ $t('whatsapp.preview_select_template_hint') }}
            </p>
          </div>
        </div>

        <!-- <Message severity="info" :closable="false" size="small">
          <div class="text-sm space-y-1 dark:text-[var(--p-text-color)]">
            <div class="font-semibold">Importante:</div>
            <ul class="list-disc list-inside space-y-1 text-xs">
              <li>
                Los templates se enviarán inmediatamente a todos los destinatarios seleccionados
              </li>
              <li>
                Los chats estarán en estado <strong>TEMPLATE</strong> hasta que el usuario responda
              </li>
              <li>Al responder, el chat será enrutado automáticamente al destino configurado</li>
            </ul>
          </div>
        </Message> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'
import {
  BotMessageSquare,
  ChevronDown,
  ChevronUp,
  MoveRight,
  Phone,
  Radio,
  User,
} from 'lucide-vue-next'
import AppAvatar from '@/components/atoms/avatar/AppAvatar.vue'
import { contactKey } from '@/components/whatsapp/services/contactIdentity'
import PreviewPhoneTemplate from '../../chat-view/PreviewPhoneTemplate.vue'
import { FormatHeader } from '@/services/templates/enums/format-header.enum'
import { TypeButton } from '@/services/templates/enums/type-button.enum'
import IconMessage from '@/assets/svg/message_icon.svg?component'
import IconPlane from '@/assets/svg/plane_icon.svg?component'
import IconAgent from '@/assets/svg/agent_icon.svg?component'
import IconCampaign from '@/assets/svg/campaign_icon.svg?component'
import IconNebula from '@/assets/svg/icon_nebula.svg?component'
import { getTemplateDisplayName } from '@/helpers/template-name.helper'

import type {
  ContactSelection,
  RoutingDestination,
  Template,
  TemplateSendComponent,
} from '@/components/whatsapp/types/interfaces'
import type {
  IButtonTemplate,
  ICarouselPayloadTemplate,
  ICarouselTemplate,
  IHeaderTemplate,
  ILimitedTimeOfferTemplate,
} from '@/services/templates/interfaces/template.interface'

type PreviewButtonSource = NonNullable<Template['content']['buttons']>[number] & {
  example?: string | null
  url?: string | null
  phone_number?: string | null
}

type PreviewContent = Template['content'] & {
  example_header?: string | null
  limited_time_offer?: ILimitedTimeOfferTemplate | null
}

type CarouselButtonType = ICarouselTemplate['buttonTypes'][number]

interface RawCarouselCardComponent {
  type?: string | null
  format?: string | null
  text?: string | null
  sub_type?: string | null
  parameters?: Array<{
    type?: string | null
    text?: string | null
    image?: { link?: string | null } | null
    video?: { link?: string | null } | null
  }> | null
}

interface RawCarouselCard {
  components?: RawCarouselCardComponent[] | null
}

interface RawCarouselComponent {
  type?: string | null
  cards?: RawCarouselCard[] | null
}

interface Props {
  contacts: ContactSelection[]
  template: Template | null
  parameters: TemplateSendComponent[] | null
  destination: RoutingDestination | null
}

const props = defineProps<Props>()
const { t } = useI18n()

const showContactsList = ref(false)

const primaryContact = computed(() => props.contacts[0] ?? null)

const primaryContactCustomFields = computed(() => {
  const fields = new Map<string, NonNullable<ContactSelection['custom_fields']>[number]>()

  primaryContact.value?.custom_fields?.forEach((field) => {
    if (!field.id) return
    fields.set(field.id, field)
  })

  return fields
})

const primaryContactAvatar = computed(() => {
  const contact = primaryContact.value as
    | (ContactSelection & { avatar?: string; photo?: string })
    | null
  return contact?.avatar || contact?.photo || ''
})

const primaryContactInitials = computed(() => {
  const fallback = primaryContact.value?.phone?.slice(0, 2) || ''
  const source = primaryContact.value?.name?.trim() || fallback

  return source
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')
})

const previewBodyExamples = computed(() => {
  if (!props.parameters) return []
  const bodyComp = props.parameters.find((c) => c.type === 'body')
  if (!bodyComp?.parameters?.length) return []
  return bodyComp.parameters
    .filter((p) => p.type === 'text')
    .map((p) => getTemplateParameterPreviewValue(p.text || ''))
})

const previewHeader = computed<IHeaderTemplate>(() => {
  const selectedHeader = props.template?.content.header

  if (!selectedHeader) {
    return {
      format: FormatHeader.NONE,
      content: '',
    }
  }

  return {
    format: selectedHeader.format as FormatHeader,
    content: selectedHeader.content || '',
  }
})

const previewExampleHeader = computed(() => {
  return (props.template?.content as PreviewContent | undefined)?.example_header ?? null
})

const previewLimitedTimeOffer = computed(() => {
  return (props.template?.content as PreviewContent | undefined)?.limited_time_offer ?? undefined
})

const previewButtons = computed<IButtonTemplate[]>(() => {
  return ((props.template?.content.buttons || []) as PreviewButtonSource[]).map((button) => ({
    ...button,
    type:
      button.type === TypeButton.PHONE_NUMBER
        ? TypeButton.VOICE_CALL
        : (button.type as Exclude<TypeButton, TypeButton.PHONE_NUMBER>),
    text: button.text,
    data: button.data ?? button.example ?? button.url ?? button.phone_number ?? null,
  }))
})

const normalizeButtonType = (type?: string | null): CarouselButtonType => {
  if (type === TypeButton.URL) return TypeButton.URL
  if (type === TypeButton.PHONE_NUMBER || type === TypeButton.VOICE_CALL) {
    return TypeButton.PHONE_NUMBER
  }

  return TypeButton.QUICK_REPLY
}

const normalizeCarousel = (carousel?: ICarouselTemplate | null): ICarouselTemplate | undefined => {
  if (!carousel?.cards?.length) return undefined

  const buttonTypes = carousel.buttonTypes?.length
    ? carousel.buttonTypes.map((type) => normalizeButtonType(type))
    : carousel.cards[0]?.buttons?.map((button) => normalizeButtonType(button.type)) || [
        TypeButton.QUICK_REPLY,
      ]

  return {
    mediaType: carousel.mediaType === FormatHeader.VIDEO ? FormatHeader.VIDEO : FormatHeader.IMAGE,
    buttonCount: (buttonTypes.length > 1 ? 2 : 1) as 1 | 2,
    buttonTypes,
    cards: carousel.cards.map((card) => ({
      media: card.media || card.mediaUrl || card.exampleMedia || '',
      body: card.body || card.sampleText || '',
      bodyExamples: card.bodyExamples || [],
      buttons: buttonTypes.map((type, index) => ({
        type,
        text: card.buttons?.[index]?.text || '',
        data:
          card.buttons?.[index]?.data ||
          card.buttons?.[index]?.phone_number ||
          card.buttons?.[index]?.url ||
          null,
      })),
    })),
  }
}

const buildCarouselFromPayloadCards = (
  cards?: ICarouselPayloadTemplate[] | null,
): ICarouselTemplate | undefined => {
  if (!cards?.length) return undefined

  const firstCardButtons = cards[0]?.buttons || []
  const buttonTypes: CarouselButtonType[] = firstCardButtons.length
    ? firstCardButtons.map((button) => normalizeButtonType(button.type))
    : [TypeButton.QUICK_REPLY]

  return {
    mediaType:
      cards[0]?.headerType === FormatHeader.VIDEO ? FormatHeader.VIDEO : FormatHeader.IMAGE,
    buttonCount: (buttonTypes.length > 1 ? 2 : 1) as 1 | 2,
    buttonTypes,
    cards: cards.map((card) => ({
      media:
        String(card.media_base64 ?? '').trim() ||
        String(card.exampleMedia ?? '').trim() ||
        String(card.mediaUrl ?? '').trim(),
      mediaUrl: card.mediaUrl,
      mediaId: card.mediaId,
      exampleMedia: card.exampleMedia,
      headerType: card.headerType || undefined,
      body: card.body || card.sampleText || '',
      sampleText: card.sampleText,
      bodyExamples: [],
      buttons: buttonTypes.map((type, index) => {
        const button = card.buttons?.[index]

        return {
          type,
          text: button?.text || '',
          data:
            button?.buttonValue || button?.url || button?.suffix || button?.example?.[0] || null,
          url: button?.url || null,
          phone_number: type === TypeButton.PHONE_NUMBER ? button?.buttonValue || null : null,
        }
      }),
    })),
  }
}

const getMediaLinkFromComponent = (component?: RawCarouselCardComponent) => {
  const mediaParameter = component?.parameters?.find((parameter) =>
    ['image', 'video'].includes(String(parameter.type).toLowerCase()),
  )

  return mediaParameter?.image?.link || mediaParameter?.video?.link || ''
}

const buildCarouselFromTemplateComponents = (): ICarouselTemplate | undefined => {
  const components = props.template?.content.template?.components as
    | RawCarouselComponent[]
    | undefined

  const carouselComponent = components?.find(
    (component) =>
      String(component.type).toLowerCase() === 'carousel' && Array.isArray(component.cards),
  )

  if (!carouselComponent?.cards?.length) return undefined

  const firstCardComponents = carouselComponent.cards[0]?.components || []
  const buttonComponents = firstCardComponents.filter(
    (component) => String(component.type).toLowerCase() === 'button',
  )
  const buttonTypes: CarouselButtonType[] = buttonComponents.length
    ? buttonComponents.map((button) => normalizeButtonType(button.sub_type))
    : [TypeButton.QUICK_REPLY]

  const mediaType =
    firstCardComponents.find((component) => String(component.type).toLowerCase() === 'header')
      ?.format === FormatHeader.VIDEO
      ? FormatHeader.VIDEO
      : FormatHeader.IMAGE

  return {
    mediaType,
    buttonCount: (buttonTypes.length > 1 ? 2 : 1) as 1 | 2,
    buttonTypes,
    cards: carouselComponent.cards.map((card) => {
      const cardComponents = card.components || []
      const headerComponent = cardComponents.find(
        (component) => String(component.type).toLowerCase() === 'header',
      )
      const bodyComponent = cardComponents.find(
        (component) => String(component.type).toLowerCase() === 'body',
      )
      const cardButtons = cardComponents.filter(
        (component) => String(component.type).toLowerCase() === 'button',
      )

      return {
        media: getMediaLinkFromComponent(headerComponent),
        body: bodyComponent?.text || bodyComponent?.parameters?.[0]?.text || '',
        bodyExamples: bodyComponent?.parameters?.map((parameter) => parameter.text || '') || [],
        buttons: buttonTypes.map((type, index) => ({
          type,
          text: cardButtons[index]?.text || '',
          data: cardButtons[index]?.parameters?.[0]?.text || null,
        })),
      }
    }),
  }
}

const previewCarousel = computed<ICarouselTemplate | undefined>(() => {
  return (
    normalizeCarousel(props.template?.content.carousel) ||
    buildCarouselFromPayloadCards(props.template?.content.cards) ||
    buildCarouselFromTemplateComponents()
  )
})

const isCarouselTemplate = computed(() => {
  return Boolean(
    previewCarousel.value ||
      String(props.template?.content.header?.format ?? '').toUpperCase() === 'CAROUSEL' ||
      props.template?.combination?.toLowerCase().includes('carousel'),
  )
})

const getTemplateCategoryLabel = (template: Template) => {
  return String(template.content.category).toUpperCase() === 'MARKETING'
    ? t('whatsapp.template_type_marketing')
    : t('whatsapp.template_type_utility')
}

const getCategoryBadgeClass = (template: Template) => {
  return String(template.content.category).toUpperCase() === 'MARKETING'
    ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-200'
    : 'bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-200'
}

const getTemplateParameterPreviewValue = (value: string) => {
  if (value === 'name') return primaryContact.value?.name?.trim() || '{{Nombre del contacto}}'
  if (value === 'phone') return primaryContact.value?.phone?.trim() || '{{Teléfono del contacto}}'

  const customField = primaryContactCustomFields.value.get(value)
  const customFieldValue = customField?.value?.trim()

  if (customFieldValue) return customFieldValue

  const customFieldName = customField?.name?.trim()
  return customFieldName ? `{{${customFieldName}}}` : value
}

const getTemplatePreview = (template: Template) => {
  const bodyComp = props.parameters?.find((c) => c.type === 'body')
  let bodyText = template.content.body || template.description || ''

  if (bodyComp?.parameters?.length) {
    bodyComp.parameters.forEach((param, idx) => {
      if (param.type === 'text' && param.text) {
        bodyText = bodyText.replace(`{{${idx + 1}}}`, getTemplateParameterPreviewValue(param.text))
      }
    })
  }

  return bodyText.replace(/\s+/g, ' ').trim() || t('whatsapp.template_without_content')
}

const previewComponents = computed(() => {
  if (!props.template) return []

  const components = []

  if (props.template.content.header?.content) {
    components.push({
      type: 'HEADER',
      text: props.template.content.header.content,
    })
  }

  let bodyText = props.template.content.body
  const bodyComp = props.parameters?.find((c) => c.type === 'body')
  if (bodyComp?.parameters?.length) {
    bodyComp.parameters.forEach((param, idx) => {
      if (param.type === 'text' && param.text) {
        bodyText = bodyText.replace(`{{${idx + 1}}}`, getTemplateParameterPreviewValue(param.text))
      }
    })
  }

  components.push({
    type: 'BODY',
    text: bodyText,
  })

  if (props.template.content.footer) {
    components.push({
      type: 'FOOTER',
      text: props.template.content.footer,
    })
  }

  return components
})
</script>
